import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DropDownItem } from '../../../models/DropDownItem';
import { getEvdaEuropeCountriesFilterState } from '../../../redux/selectors/filterSelector';
import { FilterAction } from '../../../redux/states/filterState';
import CustomDropDownList, { FilterType } from './customDropDownList';
import {MapPoint} from "../../../service/MapPoint";

  const options: DropDownItem[] = [
    
    { Element:{key: 'DE', name: 'Allemagne ' }, selected:false, hidden:false},
    { Element:{key: 'AT', name: 'Autriche'}, selected:false, hidden:false},
    { Element:{key: 'BE', name:  'Belgique'}, selected:false, hidden:false},
    { Element:{key: 'BG', name:  'Bulgarie' }, selected:false, hidden:false},
    { Element:{key: 'CY', name:  'Chypre' }, selected:false, hidden:false},
    { Element:{key: 'HR', name:  'Croatie' }, selected:false, hidden:false},
    { Element:{key: 'DK', name:  'Danemark' }, selected:false, hidden:false},
    { Element:{key: 'ES', name:  'Espagne' }, selected:false, hidden:false},
    { Element:{key: 'EE', name:  'Estonie' }, selected:false, hidden:false},
    { Element:{key: 'FI', name:  'Finlande' }, selected:false, hidden:false},
    { Element:{key: 'FR', name:  'France' }, selected:false, hidden:false},
    { Element:{key: 'GR', name:  'Grèce' }, selected:false, hidden:false},
    { Element:{key: 'HU', name:  'Hongrie' }, selected:false, hidden:false},
    { Element:{key: 'IE', name:  'Irlande' }, selected:false, hidden:false},
    { Element:{key: 'IT', name:  'Italie' }, selected:false, hidden:false},
    { Element:{key: 'LV', name:  'Lettonie' }, selected:false, hidden:false},
    { Element:{key: 'LT', name:  'Lituanie' }, selected:false, hidden:false},
    { Element:{key: 'LU', name:  'Luxembourg' }, selected:false, hidden:false},
    { Element:{key: 'MT', name:  'Malte' }, selected:false, hidden:false},
    { Element:{key: 'NL', name:  'Pays-Bas' }, selected:false, hidden:false},
    { Element:{key: 'PL', name:  'Pologne' }, selected:false, hidden:false},
    { Element:{key: 'PT', name:  'Portugal' }, selected:false, hidden:false},
    { Element:{key: 'CZ', name:  'République tchèque' }, selected:false, hidden:false},
    { Element:{key: 'RO', name:  'Roumanie' }, selected:false, hidden:false},
    { Element:{key: 'SK', name:  'Slovaquie' }, selected:false, hidden:false},
    { Element:{key: 'SI', name:  'Slovénie' }, selected:false, hidden:false},
    { Element:{key: 'SE', name:  'Suède' }, selected:false, hidden:false},
    { Element:{key: 'GB', name:  'Royaume-Uni' }, selected:false, hidden:false},
  ];
export type Props = {
    data: MapPoint[]
}
const CountrySelectionComponent:React.FC<Props>=({data})=>{
  const dispatch = useDispatch()
  const countriesFilter =useSelector(getEvdaEuropeCountriesFilterState)
  const [items,setItems]=useState<DropDownItem[]>(options)
  const { t } = useTranslation();
  useEffect(()=>{
    setItems(current =>
      current.map(obj => {
        const objData = data.find(country => country.node === obj.Element.key);
        // Lorsque la donnée actuelle correspondant à ce pays est indisponible, on n'affiche pas ce pays dans la liste
        // et on le désélectionne.
        if (!objData || objData?.esperance_de_vie === 'nd' || objData?.esperance_de_vie === 'NaN') {
          return {...obj, selected:false, hidden: true};
        }
        else if (countriesFilter.selectedCountries.filter(country=>country.Element.key===obj.Element.key).length>0) {
          return {...obj, selected:true, hidden: false};
        }
        else{
          return {...obj, selected:false, hidden: false};
        }
      }),
    );
  },[countriesFilter.selectedCountries, data]);

    const onSetCountriesSelection=(selection:DropDownItem)=>{
      dispatch(FilterAction.setEvdaEuropeCountrySelection(selection))
  }
    return (<div className='filter-type-container'>
        <label>{t("filter_label_countries")}</label>
        <div>
        <CustomDropDownList enableTranslate={true} filterType={FilterType.Country} emptyField={t('no_country_selected')} items={items}  onSetSelection={onSetCountriesSelection} ></CustomDropDownList>
        </div>
    </div>)
}

export default  CountrySelectionComponent